/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_NewInputs */

const en_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's New`)
};

const fr_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveautés`)
};

const de_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist neu`)
};

const it_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa c'è di nuovo`)
};

const ru_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что нового`)
};

const es_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué hay de nuevo`)
};

const zh_cn2_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是新的`)
};

const ja_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新着情報`)
};

const hi_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया क्या है`)
};

const pt_pt2_whats_new = /** @type {(inputs: Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que há de novo`)
};

/**
* | output |
* | --- |
* | "What's New" |
*
* @param {Whats_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const whats_new = /** @type {((inputs?: Whats_NewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_NewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_whats_new(inputs)
	if (locale === "de") return de_whats_new(inputs)
	if (locale === "it") return it_whats_new(inputs)
	if (locale === "ru") return ru_whats_new(inputs)
	if (locale === "es") return es_whats_new(inputs)
	if (locale === "zh-CN") return zh_cn2_whats_new(inputs)
	if (locale === "ja") return ja_whats_new(inputs)
	if (locale === "hi") return hi_whats_new(inputs)
	if (locale === "pt-PT") return pt_pt2_whats_new(inputs)
	return en_whats_new(inputs)
});